import React, { useState } from 'react';

export default function SchoolLoginDesign5() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-red-900 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background shapes */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-red-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute -bottom-8 left-20 w-80 h-80 bg-slate-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

      <div className="w-full max-w-md relative z-10">
        <div className="bg-slate-800 bg-opacity-80 backdrop-blur-xl rounded-3xl shadow-2xl overflow-hidden border border-slate-700">
          {/* Header */}
          <div className="bg-gradient-to-br from-red-600 to-red-800 px-8 py-16 text-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0 bg-[repeating-linear-gradient(45deg,transparent,transparent_35px,rgba(255,255,255,.1)_35px,rgba(255,255,255,.1)_70px)]"></div>
            </div>
            <div className="relative">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-red-300 to-red-400 rounded-full flex items-center justify-center shadow-2xl">
                  <span className="text-4xl">🎯</span>
                </div>
              </div>
              <h1 className="text-4xl font-black text-white mb-2">APEX ACADEMY</h1>
              <p className="text-red-100 font-light tracking-widest uppercase text-xs">Excellence in Education</p>
            </div>
          </div>

          {/* Form */}
          <div className="px-8 py-12 space-y-6">
            <div>
              <label className="block text-xs font-bold text-red-400 mb-3 uppercase tracking-widest">Admin ID</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@apexacademy.com"
                className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-500 focus:ring-opacity-30 transition"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-red-400 mb-3 uppercase tracking-widest">Master Key</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-500 focus:ring-opacity-30 transition"
              />
            </div>

            <div className="flex items-center justify-between pt-2">
              <label className="flex items-center gap-2 text-sm text-slate-300">
                <input type="checkbox" className="w-4 h-4 rounded bg-slate-700 border-slate-600" />
                Secure Session
              </label>
              <a href="#" className="text-sm text-red-400 hover:text-red-300 font-bold">Need Access?</a>
            </div>

            <button className="w-full bg-gradient-to-r from-red-600 to-red-700 text-white font-bold py-3 rounded-lg hover:from-red-700 hover:to-red-800 transition duration-300 shadow-lg hover:shadow-red-600/50 uppercase tracking-wide">
              Authenticate
            </button>

            <div className="grid grid-cols-2 gap-3 pt-4">
              <button className="py-2 bg-slate-700 border border-slate-600 rounded-lg text-slate-300 text-xs font-semibold hover:border-red-500 transition">ADMIN LOGIN</button>
              <button className="py-2 bg-slate-700 border border-slate-600 rounded-lg text-slate-300 text-xs font-semibold hover:border-red-500 transition">STAFF LOGIN</button>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-slate-900 border-t border-slate-700 px-8 py-4">
            <p className="text-xs text-slate-500 text-center">Apex Academy Management System v2.0</p>
          </div>
        </div>

        <p className="text-center text-slate-400 text-xs mt-6">Secure Enterprise Solution</p>
      </div>
    </div>
  );
}
